module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Renee-meisje-goudfolie-emboss-preeg-crush-papier-corn-drukwerk-1.15d3f6a2.jpg";